module.exports = require("react-collapse");


/*****************
 ** WEBPACK FOOTER
 ** external "react-collapse"
 ** module id = 71
 ** module chunks = 0
 **/